function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M16 16a1 1 0 100 2h1a1 1 0 100-2h-1z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 12.429A2.429 2.429 0 0112.429 10h7.142A2.429 2.429 0 0122 12.429v7.142A2.429 2.429 0 0119.571 22H12.43A2.429 2.429 0 0110 19.571V12.43zM12.429 12a.429.429 0 00-.429.429v7.142c0 .237.192.429.429.429h7.142a.429.429 0 00.429-.429V12.43a.429.429 0 00-.429-.429H12.43z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16 2a1 1 0 011 1v1.786h4.5V3a1 1 0 112 0v1.786h.857a2.857 2.857 0 012.857 2.857V8.5H29a1 1 0 110 2h-1.786V15H29a1 1 0 110 2h-1.786v4.5H29a1 1 0 110 2h-1.786v.857a2.857 2.857 0 01-2.857 2.857H23.5V29a1 1 0 11-2 0v-1.786H17V29a1 1 0 11-2 0v-1.786h-4.5V29a1 1 0 11-2 0v-1.786h-.857a2.857 2.857 0 01-2.857-2.857V23.5H3a1 1 0 110-2h1.786V17H3a1 1 0 110-2h1.786v-4.5H3a1 1 0 110-2h1.786v-.857a2.857 2.857 0 012.857-2.857H8.5V3a1 1 0 012 0v1.786H15V3a1 1 0 011-1zM6.786 24.357c0 .474.383.857.857.857h16.714a.857.857 0 00.857-.857V7.643a.857.857 0 00-.857-.857H7.643a.857.857 0 00-.857.857v16.714z",
  fill: "currentColor"
})));